import { render } from "./UiTemplatesFragmentsList.vue?vue&type=template&id=4fc6804b&scoped=true"
import script from "./UiTemplatesFragmentsList.vue?vue&type=script&lang=js"
export * from "./UiTemplatesFragmentsList.vue?vue&type=script&lang=js"

import "./UiTemplatesFragmentsList.vue?vue&type=style&index=0&id=4fc6804b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc6804b"]])

export default __exports__